export default function SectionAbout() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20 border-t border-background-200">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">关于我们</h2>
          <p className="text-sm text-foreground-500 mb-10">了解91麻豆免费视频网站的使命与价值</p>

          <div className="bg-background-50 border border-background-200 rounded-2xl p-8 md:p-10 text-left">
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              91麻豆免费视频网站成立于2019年，是国内领先的<strong>免费视频在线观看</strong>平台。
              我们致力于为广大用户提供海量优质的<strong>91免费在线视频</strong>资源，
              打造一站式<strong>在线免费视频网站</strong>服务体验。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              平台汇聚了<strong>91免费视频网站</strong>最全面的频道分类，
              涵盖<strong>91福利在线视频</strong>、<strong>免费高清视频在线</strong>等热门板块，
              <strong>91在线观看视频网站</strong>采用先进的视频技术与全球CDN加速，
              确保每一位用户都能享受流畅不缓冲的观看体验。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              我们的内容团队每日精选<strong>91福利视频在线</strong>优质资源，
              保持高频更新节奏，让平台始终保持新鲜活力。
              从经典回顾到热门新作，91麻豆免费视频网站始终是您最值得信赖的<strong>免费视频在线观看</strong>伙伴。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed">
              未来我们将持续优化产品体验，拓展更多优质内容，
              让91麻豆免费视频网站成为每一位视频爱好者每日必访的<strong>在线免费视频网站</strong>。
              感谢每一位用户的支持与陪伴。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            {[
              { num: '6+', label: '运营年限' },
              { num: '10,000+', label: '视频资源' },
              { num: '500万+', label: '月活用户' },
              { num: '99.9%', label: '服务可用率' },
            ].map((s, i) => (
              <div key={i} className="text-center p-4 rounded-xl bg-background-100 border border-background-200">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading mb-1">{s.num}</div>
                <div className="text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}